module.exports = __webpack_public_path__ + "img/working-out.77d697b0.png";